import React from "react";

interface SettingsIconProps extends React.SVGProps<SVGSVGElement> {
  size?: string | number;
  color?: string;
}

export const FileManagementIcon: React.FC<SettingsIconProps> = ({
  size = 24,
  color = "#40599B",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17 22L16.7 20.5C16.5 20.4167 16.3125 20.3292 16.1375 20.2375C15.9625 20.1458 15.7833 20.0333 15.6 19.9L14.15 20.35L13.15 18.65L14.3 17.65C14.2667 17.45 14.25 17.2333 14.25 17C14.25 16.7667 14.2667 16.55 14.3 16.35L13.15 15.35L14.15 13.65L15.6 14.1C15.7833 13.9667 15.9625 13.8542 16.1375 13.7625C16.3125 13.6708 16.5 13.5833 16.7 13.5L17 12H19L19.3 13.5C19.5 13.5833 19.6875 13.6708 19.8625 13.7625C20.0375 13.8542 20.2167 13.9667 20.4 14.1L21.85 13.65L22.85 15.35L21.7 16.35C21.7333 16.55 21.75 16.7667 21.75 17C21.75 17.2333 21.7333 17.45 21.7 17.65L22.85 18.65L21.85 20.35L20.4 19.9C20.2167 20.0333 20.0375 20.1458 19.8625 20.2375C19.6875 20.3292 19.5 20.4167 19.3 20.5L19 22H17ZM18 19C18.55 19 19.0208 18.8042 19.4125 18.4125C19.8042 18.0208 20 17.55 20 17C20 16.45 19.8042 15.9792 19.4125 15.5875C19.0208 15.1958 18.55 15 18 15C17.45 15 16.9792 15.1958 16.5875 15.5875C16.1958 15.9792 16 16.45 16 17C16 17.55 16.1958 18.0208 16.5875 18.4125C16.9792 18.8042 17.45 19 18 19ZM4 18V6V10.3V10V18ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H10L12 6H20C20.55 6 21.0208 6.19583 21.4125 6.5875C21.8042 6.97917 22 7.45 22 8V11.275C21.7 11.0583 21.3833 10.8708 21.05 10.7125C20.7167 10.5542 20.3667 10.4167 20 10.3V8H11.175L9.175 6H4V18H11.075C11.125 18.35 11.2042 18.6917 11.3125 19.025C11.4208 19.3583 11.55 19.6833 11.7 20H4Z"
      fill={color}
    />
  </svg>
);

export default FileManagementIcon;
